import React from 'react';
import { Web3Button } from '@web3modal/react';

function PromptLogin() {
  return (
    <div className="p-3 pt-5 " style={{ height: '100vh' }}>
      <h4 align="center" className='text-light' variant="h4">
        Please connect Your wallet
        <br />
        <br />
        <Web3Button/>
      </h4>
    </div>
  );
}

export default PromptLogin;
